import React from 'react';
import ArrowUp from '../../../icons/ArrowUp';
import ArrowDown from '../../../icons/ArrowDown';

const SortBySection = ({
  active,
  handleActive,
  showSortby,
  setSortOrder,
  sortByHandle,
  showSortAsc,
  applySortFlightsSettings
}) => {
  return (
    <div className="txtRight">
      <div className="posRel">
        <span>
          <span className="f500 font10 greyCnt">Sort by : </span>
          <span onClick={handleActive} className="blueCnt f500 font10 posRel marginR5">
            {showSortby}
          </span>
          <span
            onClick={() => {
              setSortOrder(!showSortAsc);
              applySortFlightsSettings(showSortby.toLowerCase(), !showSortAsc);
            }}
          >
            {!showSortAsc ? (
              <ArrowUp width="1rem" height="1rem" />
            ) : (
              <ArrowDown width="1rem" height="1rem" />
            )}
          </span>
        </span>

        {active && (
          <ul className="sortByoptions">
            <li
              onClick={() => {
                sortByHandle('CHEAPEST');
                applySortFlightsSettings('cheapest', showSortAsc);
              }}
              className="active"
              key="cheapest"
            >
              CHEAPEST
            </li>
            <li
              onClick={() => {
                sortByHandle('SHORTEST');
                applySortFlightsSettings('shortest', showSortAsc);
              }}
              key="shortest"
            >
              SHORTEST
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};
export default SortBySection;
